<template>
  <div class="chain-browser-home-page">
    <div class="page-header">
      <div class="site-logo">
        <p class="page-title">绿色电碳服务链</p>
      </div>
      <ul class="tabs" @click.stop="tabHandle">
        <li class="tab-pane" :class="{active: 'node' === activeName}" name='node'>节点</li>
        <li class="tab-pane" :class="{active: 'block' === activeName}" name='block'>区块</li>
        <li class="tab-pane" :class="{active: 'tx' === activeName}" name='tx'>交易列表</li>
        <li class="tab-pane" :class="{active: 'contr' === activeName}" name='contr'>智能合约</li>

      </ul>
      <!--
      <div class="join" @click="jumpTo('/join/index')">平台数据</div>
        -->
      <!-- <el-switch
        v-model="themeData"
        active-color="#14142e"
        inactive-color="#b5b5b5"
        inactive-text="主题切换"
        @change="themeChange">
      </el-switch> -->
    </div>
    <div class="content-container">
      <block-section ref="block" :class="blockCurrentClass"  :current-is-new="currentIsNew" @callback="changeSectionP" @animationClick="blockRowClick"
      @currentNew="currentNewHandle" @averCallBack="averHandle" />
      <node-section ref="node" :class="nodeCurrentClass" :themeData="themeData" @callback="changeSectionP"/>
      <contr-section ref="contr" :themeData="themeData" :class="contrCurrentClass" @callback="changeSectionP"/>
      <tx-section ref="tx" :totalNm="totalNm" :class="txCurrentClass"  @callback="changeSectionP"/>
      <div class="section-top-right">
        <div class="block-one">
          <img class="icon" :src="themeData ? require('../assets/icon/home-1Icon@2x.svg') : require('../assets/icon/home-1Icon@2x.png')" alt="">
          <div class="text-box">
            <p class="label">平均出块时间</p>
            <p class="text">{{averageTime}}</p>
          </div>
        </div>
        <div class="block-two">
          <div class="item-box">
            <p class="back-new-block" @click="buttonHandle" v-show="buttonShow">返回新块</p>
            <div class="icon-item">
              <img class="icon" :src="themeData ? require('../assets/icon/home-2Icon@2x.svg') : require('../assets/icon/home-2Icon@2x.png')" alt="">
              <div class="text-box">
                <p class="label">{{numberTitle}}</p>
                <p class="text"><DigitRoll :rollDigits="currentBlockNm" /></p>
              </div>
            </div>
            <div class="icon-item">
              <img class="icon" :src="themeData ? require('../assets/icon/pointicon@2x.svg') : require('../assets/icon/pointicon@2x_1.svg')" alt="">
              <div class="text-box">
                <p class="label">出块节点</p>
                <p class="text node">{{stateRoot}}</p>
              </div>
            </div>
          </div>
          <p class="ani-text">出块节点同步</p>
          <div class="ani-container"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockSection from './blockPage'
import NodeSection from './nodePage'
import ContrSection from './contrPage'
import TxSection from './txPage'
import lottie from 'lottie-web'
import DigitRoll from '@huoyu/vue-digitroll'
import { Loading } from 'element-ui'

export default {
  data() {
    return {
      blockCurrentClass: 'section-center',
      txCurrentClass: 'section-bottom-right',
      contrCurrentClass: 'section-bottom-left',
      nodeCurrentClass: 'section-left',
      currentName: '',
      centerName: '',
      activeName: '',
      averageTime: '',
      stateRoot: '',
      numberTitle: '最新块',
      currentBlockNm: 0,
      clickUse: true,
      buttonShow: false,
      currentIsNew: true,
      totalNm: 0,
      loadingDom: null,
      themeData: true,
    }
  },
  components: {
    BlockSection,
    NodeSection,
    ContrSection,
    TxSection,
    DigitRoll
  },
  computed: {},
  created () {
    this.loadingDom = Loading.service({fullscreen: true, background: 'rgba(0,0,0, .9)'})
  },
  mounted() {
    let _self = this
      _self.loadingDom.close()

    window.onload = function () {
      _self.loadingDom.close()
      _self.reloadAnimation()
    }
  },
  methods: {
    tabHandle(e) {
      if (!this.clickUse) return
      let elName = e.target.getAttribute('name')
      if (elName === 'case' || elName === 'intro') {
        switch (elName) {
          case 'case':
            this.$router.push({path: '/casePage'})
            break;

          default:
            break;
        }
      } else {
        this.activeName = elName
        let pageRoot = document.querySelector(`.${elName}-section-page`)
        this.changeSectionP(pageRoot)
      }
    },
    changeSectionP(el) {
      this.clickUse = false
      let _self = this
      let currentEl = el
      let currentSection = currentEl.classList[1].split('section-')[1]
      this.currentName = currentEl.classList[0].split('-')[0]

      let centerEl = document.querySelector('.section-center')
      this.centerName = centerEl.classList[0].split('-')[0]

      // 清除in-class
      centerEl.classList.remove('center-in')
      currentEl.classList.remove(`${currentSection}-in`)


      // 淡出section
      centerEl.classList.toggle('center-out')
      currentEl.classList.toggle(`${currentSection}-out`)

      setTimeout(function() {
        currentEl.classList.replace(`section-${currentSection}`, 'section-center')
        currentEl.classList.replace(`${currentSection}-out`, 'center-in')
        centerEl.classList.replace('section-center', `section-${currentSection}`)
        centerEl.classList.replace('center-out', `${currentSection}-in`)
        _self.renderChart(_self.currentName, _self.centerName)
      }, 500, centerEl, currentEl, _self)

      // 限制点击nav频率太快
      setTimeout(() => {
        _self.clickUse = true
      }, 1500);
    },
    renderChart(currentName, centerName) {
      let centerVm = this.$refs[centerName]
      let currentVm = this.$refs[currentName]
      // if (centerVm)
      if (currentName === 'node') {
        currentVm.renderMap()
      }

      if (['tx'].includes(centerName)) {
        centerVm.renderLineChart()
      }

      if (['tx'].includes(currentName)) {
        currentVm.renderLineChart()
      }

      if (['contr'].includes(centerName)) {
        centerVm.renderContrChart()
      }

      if (['contr'].includes(currentName)) {
        currentVm.renderContrChart()
      }

      if (['block'].includes(centerName)) {
        centerVm.backIndex()
      }

      if (['block'].includes(currentName)) {
        currentVm.backIndex()
      }
    },
    blockRowClick (data) {
      this.numberTitle = '当前块'
      this.buttonShow = true
      this.currentIsNew = false
      this.currentBlockNm = data.number_1
      this.stateRoot = data.stateRoot
      this.reloadAnimation()
    },
    currentNewHandle(data) {
      this.numberTitle = '最新块'
      this.buttonShow = false
      this.currentIsNew = true
      this.currentBlockNm = data.number_1
      this.totalNm = data.number_1
      this.stateRoot = data.stateRoot
      this.reloadAnimation()
    },
    averHandle(data) {
      this.averageTime = data
    },
    buttonHandle () {
      this.currentIsNew = true
      this.$refs.block.fetchBlockList()
    },
    reloadAnimation () {
      let elDom = document.querySelector('.ani-container')
      // 删除存在的子节点
      if (elDom.children.length > 0) {
        let children = elDom.children[0]
        elDom.removeChild(children)
      }
      let aniPath = require(`../assets/animation/data${parseInt(Math.random()*(4-1+1)+1,10)}.json`)
// let aniPath = require(`../assets/animation/data5`)
      lottie.loadAnimation({
        container: elDom,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: aniPath
      })
    },
    themeChange(val) {
      // console.log(val)
      let data = val ? 'light' : 'dark'
      this.$refs.block.initAnimation(data)
      this.$refs.tx.themeHandle(data)
      this.$refs.node.themeHandle(data)
      if (data === 'light') {
        document.getElementsByTagName('body')[0].style.setProperty('--maincolor', '#F2F2F2')
        document.getElementsByTagName('body')[0].style.setProperty('--areacolor', '#fff')
        document.getElementsByTagName('body')[0].style.setProperty('--fontcolor', '#2C49B1')
      } else if (data === 'dark') {
        document.getElementsByTagName('body')[0].style.setProperty('--maincolor', '#050510')
        document.getElementsByTagName('body')[0].style.setProperty('--areacolor', '#14142e')
        document.getElementsByTagName('body')[0].style.setProperty('--fontcolor', '#fff')
      }
    },
    jumpTo(path) {
      window.open(path, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/init-css.scss';
$page-pd: 0;
$left-right-wd: 20.65%;
$section-margin-V: .2rem;
$section-margin-H: .4rem;
$page-padding: 0rem;
$container-margin-H: .4rem;
$container-margin-V-top: .3rem;
$container-margin-V-bottom: .3rem;
$container-hg: calc(100vh - #{$page-header-hg + $container-margin-V-top + $container-margin-V-bottom});
$center-hg: 100%;
$center-left: calc(#{$left-right-wd} + #{$section-margin-H});
$center-bottom-wd: calc(100% - #{$left-right-wd}*2 - #{$section-margin-H}*2);
$bottom-Y: calc(#{$center-hg} + #{$section-margin-V});
$bottom-X: calc(#{$left-right-wd} + #{$section-margin-V});


$section-left-right-hg: 60%;
$section-bottom-left-right-hg: calc(100% - #{$section-left-right-hg} - #{$section-margin-V});
$section-bottom-left-right-Y: calc(#{$section-left-right-hg} + #{$section-margin-V});

$time-in: .5s;
$time-out: .5s;
$area-radius: 25px;

.chain-browser-home-page::v-deep {
  background: $main-background;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 $page-padding $page-padding $page-padding;
  .page-header {
    background: $theme-color;
    height: $page-header-hg;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: .3rem;
    color: #fff;
    padding-right: 30px;

    .tab-pane {
      font-size: 16px;
      cursor: pointer;
    }

    .site-logo {
      display: flex;
      padding: 0 .3rem;
      margin-right: .6rem;
      min-width: 3rem;
      align-items: center;
      >img {
        height: 36px;
      }
      .page-title {
        font-weight: bold;
        font-size: 20px;
        margin-left: .15rem;
      }
    }

    .tabs {
      display: flex;
      list-style: none;
      font-size: 20px;
      height: .5rem;
      position: relative;
      top: .11rem;
      flex: 1;

      >li {
        width: 2rem;

        &:hover, &.active {
          font-weight: bold;
          border-bottom: 2px solid #3043ef;
        }
      }
    }
    .join{
      font-size: 16px;
      width: 135px;
      height: 40px;
      line-height: 40px;
      float: right;
      margin-right: 54px;
      color: #fff;
      cursor : pointer;
    }
  }
  .content-container {
    position: relative;
    height: $container-hg;
    box-sizing: border-box;
    margin: $container-margin-V-top $container-margin-H $container-margin-V-bottom $container-margin-H;

    .section-center {
      position: absolute;
      top: $page-pd;
      left: $center-left;
      width: $center-bottom-wd;
      height: $center-hg;
      &.center-out {
        animation: center-move-out $time-out linear 0s  normal forwards;
      }

      &.center-in {
        animation: center-move-in $time-in ease-out 0s  normal forwards;
      }
    }

    .section-left {
      position: absolute;
      top: $page-pd;
      left: $page-pd;
      height: $section-left-right-hg;
      width: $left-right-wd;
      &.left-out {
        animation: left-move-out $time-out linear 0s  normal forwards;
      }

      &.left-in {
        animation: left-move-in $time-in ease-out 0s  normal forwards;
      }
    }

    .section-bottom-left {
      height: $section-bottom-left-right-hg;
      position: absolute;
      top: $section-bottom-left-right-Y;
      left: $page-pd;
      width: $left-right-wd;
      &.bottom-left-out {
        animation: bottom-left-move-out $time-out ease-in 0s  normal forwards;
      }

      &.bottom-left-in {
        animation: bottom-left-move-in $time-in ease-in 0s  normal forwards;
      }
    }

    .section-top-right {
      height: $section-left-right-hg;
      position: absolute;
      top: 0;
      right: $page-pd;
      width: $left-right-wd;

      .block-one, .block-two {
        border-radius: $area-radius;
        background: $area-background;
        padding: .4rem;
        box-sizing: border-box;
      }

      .block-one {
        margin-bottom: $section-margin-V;
        height: 18%;
        display: flex;
        padding: 2% .4rem;
        align-items: center;
        .icon {
          width: .6rem;
          height: .6rem;
        }
        .text-box {
          margin-left: .2rem;
          font-size: .16rem;
          text-align: left;
          .text {
            font-size: .26rem;
            color: $theme-font-color;
            line-height: 2.5;
          }
        }
      }

      .block-two {
        box-sizing: border-box;
        height: 80%;

        .ani-text {
          font-size: .18rem;
          text-align: left;
        }

        .item-box {
          position: relative;
          .back-new-block {
            cursor: pointer;
            position: absolute;
            right: 0;
            background: #58588C;
            border-radius: 10px;
            padding: .1rem .2rem;
            font-size: .26rem;
          }
          .icon-item {
            display: flex;
            &:last-child {
              margin-top: .2rem;
            }
            .icon {
              width: .6rem;
              height: .6rem;
            }
            .text-box {
              margin-left: .2rem;
              font-size: .16rem;
              text-align: left;
              .text {
                font-size: .26rem;
                color: $theme-font-color;
                line-height: 2.5;
                &.node {
                  width: 2rem;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  box-sizing: content-box;
                }
              }
            }
          }
          .d-roll-wrapper {
            margin: 0 auto;
          }
        }

        .ani-container {height: 60%;}
      }
    }

    .section-bottom-right {
      position: absolute;
      top: $section-bottom-left-right-Y;
      right: $page-pd;
      width: $left-right-wd;
      height: $section-bottom-left-right-hg;
      &.bottom-right-out {
        animation: right-move-out $time-out ease-in 0s  normal forwards;
      }

      &.bottom-right-in {
        animation: right-move-in $time-in ease-in 0s  normal forwards;
      }
    }
  }



  // @keyframes section-left-in-animation {
  //   0% {
  //     transform: translateX(-105%)
  //   }

  //   30% {
  //     transform: translateX(-10%)
  //   }

  //   100% {
  //     transform: translateX(0)
  //   }
  // }

  // @keyframes section-left-out-animation {
  //   0% {
  //     transform: translateX(0)
  //   }

  //   30% {
  //     transform: translateX(-10%)
  //   }

  //   100% {
  //     transform: translateX(-105%)
  //   }
  // }

  @keyframes center-move-in  {
    0% {
      transform: scale(0.7);
      opacity: 0;
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes center-move-out {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.7);
      opacity: 0;
    }
  }

  @keyframes right-move-in {
    0% {
      transform: scale(0.7);
      opacity: 0;
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes right-move-out {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.7);
      opacity: 0;
    }
  }

  @keyframes left-move-in {
    0% {
      transform: scale(0.7);
      opacity: 0;
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes left-move-out {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.7);
      opacity: 0;
    }
  }

  @keyframes bottom-left-move-in {
    0% {
      transform: scale(0.7);
      opacity: 0;
    }

    100% {
      transform: scale(1);
    }
  }

  @keyframes bottom-left-move-out {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.7);
      opacity: 0;
    }
  }

  /**element common styles */
  .el-table {
    background: transparent;
    color: #000;
    font-size: 16px;
    .el-table__header  th.is-leaf{
      height: 70px;
      color: #000;
    }
    td, th.is-leaf {
      border-bottom: 1px solid #C0D4EC;
    }
    .el-table__body {
      tr:hover>td{
        background-color: transparent!important;
      }

      .el-table__row >td:first-child {
        color: $theme-font-color;
      }

      .hash-wrapper {
        max-width: 2rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

    }
    .el-table__row {
      cursor: pointer;
    }
  }
}

</style>
